export const showSkeelo = (planId: string): boolean => {
  const plans = [
    "e6647dbe-b7df-4dd4-8323-7ad638c10ca6",
    "41a68b43-fde4-4795-bca1-a1dd311a34e9",
  ];
  return plans.includes(planId);
};
